(function($, undef) {
    var UPLOAD_COUNTER = 0;

    var defaultOptions = {
        uploadUrl: '/fileupload/',
        deleteUrl: '/fileupload/clear/',
        containerClass: 'fileupload',
        linkClass: 'fileupload__link',
        linkTarget: '_blank',
        deleteClass: 'fileupload__delete',
        uploadClass: 'fileupload__upload',
        uploadingClass: 'is-uploading',
        deletingClass: 'is-deleting',
        deleteText: 'удал.',
        uploadText: 'загр.',
        deleteTitle: 'Удалить файл',
        uploadTitle: 'Загрузать файл',
        uploadOnChange: true,
        deleteOnDelete: false,
        beforeUpload: function() {},
        beforeDelete: function() {},
        afterUpload: function(data) {},
        afterDelete: function(data) {}
    };

    var FileUploader = function(input, options) {
        this.input = input;
        this.opt = options;
        this.setup();
    }
    FileUploader.prototype = {
        setup: function() {
            var self = this;

            this.$input = $(this.input);

            this.default = this.$input.data();

            var NUMBER = UPLOAD_COUNTER ++;
            var frameName = "__upload_frame_"+NUMBER;

            this.$container = $(document.createElement('div')).addClass(this.opt.containerClass).insertAfter(this.$input);
            this.$link = $(document.createElement('a')).attr({href: '#', target: this.opt.linkTarget}).addClass(this.opt.linkClass).appendTo(this.$container);
            this.$delete = $(document.createElement('a')).attr({href: '#', title: this.opt.deleteTitle}).text(this.opt.deleteText).addClass(this.opt.deleteClass).appendTo(this.$container).click(function() { self.delete.call(self); return false; });
            this.$upload = $(document.createElement('a')).attr({href: '#', title: this.opt.uploadTitle}).text(this.opt.uploadText).addClass(this.opt.uploadClass).appendTo(this.$container).click(function() { self.upload.call(self); return false; });
            if (this.opt.uploadOnChange)  this.$upload.hide();
            this.$iframe = $(document.createElement('iframe')).attr({ src: "", name: frameName }).load(function(){ self.load.call(self, this) }).hide().appendTo(document.body);
            this.$form = $(document.createElement('form')).attr({
                method: "post",
                enctype: "multipart/form-data",
                target: frameName,
                action: this.opt.uploadUrl
            }).hide().appendTo(document.body);

            this.onUpload = function() {
                self.upload.call(self);
            }
            this.onChange = function() {
                if (self.opt.uploadOnChange) self.upload.call(self);
            }
            this.onSubmit = function() {
                self.$input.attr({disabled: true});
            }
            this.onReset = function() {
                self.$input.data(self.default).attr({ disabled: false });
                self.$subinput.val(self.default.file_id);
                self.check();
            }

            if (this.input.form) {
                this.defaultInputName = this.input.name;
                this.$subinput = $(document.createElement('input')).attr({type: 'hidden', name: this.defaultInputName, value: this.default.file_id}).appendTo(this.input.form);
                this.input.name = "__upload_input_"+NUMBER;
                $(this.input.form).on('submit', this.onSubmit).on('reset', this.onReset);
            }

            this.$input.on('change', this.onChange).on('upload', this.onUpload);

            this.check();
        },
        check: function() {
            this.$input.val('');
            var fileId = this.$input.data('file_id');
            if (fileId > 0) {
                var fileSrc = this.$input.data('file_src') || '';
                var fileName = this.$input.data('publ_name') || fileSrc.replace(/^.*?([^\/]+)$/, "$1");
                this.$link.text(fileName).attr({ href: fileSrc }).show();
                this.$delete.show();
                this.$input.hide().prop({ disabled: true });
                if (!this.opt.uploadOnChange) this.$upload.hide();
            } else {
                this.$link.attr({ href: '#' }).empty().hide();
                this.$delete.hide();
                this.$input.show().prop({ disabled: false });
                if (!this.opt.uploadOnChange) this.$upload.show();
            }
            if (this.input.form) this.$subinput.val(fileId);
        },
        upload: function() {
            if (!this.input.value) {
                alert("Вы не выбрали файл!");
                return;
            }
            this.opt.beforeUpload.call(this.input);

            var $input = this.$input;
            var data = $input.data();
            this.$input = $input.clone(true).insertAfter(this.$input);
            this.input = this.$input.get(0);
            this.$form.empty().attr({ action: this.opt.uploadUrl }).append($input.attr({ name: 'upload' }));

            for (var p in data) {
                if (data[p] == '' || p == 'file_id' || p == 'file_src' || p == 'publ_name') continue;
                this.$form.append($(document.createElement('input')).attr({ type: 'hidden', name: p, value: data[p] }))
            }

            this.$container.addClass(this.opt.uploadingClass);

            this.$form.submit();
        },
        delete: function() {
            this.opt.beforeDelete.call(this.input);

            if (this.justUploaded || this.opt.deleteOnDelete) {
                var fileId = this.$input.data('file_id');
                if (fileId > 0) {
                    this.$form.empty().attr({ action: this.opt.deleteUrl });
                    $(document.createElement('input')).attr({ type: 'hidden', name: 'file_id', value: fileId }).appendTo(this.$form);

                    this.$container.addClass(this.opt.deletingClass);

                    this.$form.submit();
                }
                this.justUploaded = false;
            } else {
                this.$input.data({ file_id: '', file_src: '', publ_name: '' });
                this.check();
            }
        },
        load: function(iframe) {
            var self = this;
            var d = null;
            if (iframe.contentDocument) d = iframe.contentDocument
            else if (iframe.contentWindow) d = iframe.contentWindow.document;
            if (!d || d.location.href == "about:blank") return;
            if (d) {
                var data = eval(d.body.innerHTML);
                if (data.method == 'upload') {
                    this.$container.removeClass(this.opt.uploadingClass);

                    if (data.error) {
                        alert("Произошла ошибка при загрузке файла");
                        this.$input.data({ file_id: null, file_src: null, publ_name: null });
                    } else {
                        self.justUploaded = true;
                        for (var p in data) {
                            if (data[p] == '' || p == 'method' || p == 'ok') continue;
                            self.$input.data(p, data[p]);
                        }
                        self.opt.afterUpload.call(self.input, data);
                    }
                } else if (data.method == 'clear') {
                    this.$container.removeClass(this.opt.deletingClass);

                    if (data.error) {
                        alert("Произошла ошибка при удалении файла");
                    } else {
                        this.$input.data({ file_id: null, file_src: null, publ_name: null });
                        self.opt.afterDelete.call(self.input, data);
                    }
                } else {
                    console.error("Unknown method", data.method);
                }
                self.check();
            }
        },
        destroy: function() {
            if (this.justUploaded) {
                var fileId = this.$input.data('file_id');
                if (fileId > 0) {
                    this.$form.empty().attr({ action: this.opt.deleteUrl });
                    $(document.createElement('input')).attr({ type: 'hidden', name: 'file_id', value: fileId }).appendTo(this.$form);
                    this.$form.submit();
                }
                this.justUploaded = false;
            }
            this.$link.remove();
            this.$delete.remove();
            this.$upload.remove();
            this.$container.remove();
            this.$form.remove();
            this.$iframe.remove();
            this.$input.off('change', this.onChange).off('upload', this.onUpload).show();
            if (this.input.form) {
                this.input.name = this.defaultInputName;
                this.$subinput.remove();
                $(this.input.form).off('submit', this.onSubmit).off('reset', this.onReset);
            }
        }
    };

    $.fn.extend({
        fileupload: function(options) {
            for (var i = 0; i < this.length; i ++) {
                if (!this[i].fileuploader) {
                    this[i].fileuploader = new FileUploader(this.get(i), $.extend({}, defaultOptions, options));
                }
            }
            return this;
        },
        unfileupload: function() {
            for (var i = 0; i < this.length; i ++) {
                if (this[i].fileuploader) {
                    this[i].fileuploader.destroy();
                    delete this[i].fileuploader;
                }
            }
        }
    });
})(jQuery);
